export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_TARIFF = 'AUTH_TARIFF';
export const AUTH_GET_MY_USER = 'AUTH_GET_MY_USER';
export const AUTH_SET_IS_LOGGED_IN = 'AUTH_SET_IS_LOGGED_IN';
export const AUTH_ADD_TARIFF_PRICE= 'AUTH_ADD_TARIFF_PRICE';
